import type { ContinuationTarget } from "~/helpers/pendingIntentLifecycle";
import type { ReceiverIdentityAdapter } from "~produce/production/helpers/continuationAdapter";

import { ITEMS_PATH } from "~restock/data-management/items/helpers/itemsRoutes";

export const RESTOCK_ITEM_TARGET_KIND = "restockItem";

export const RESTOCK_ITEMS_DOCK_PAGE_ID = "data-management-items";

const RESTOCK_ITEM_ROUTE_PATTERN = /^\/restock\/data-management\/items\/([^/?#]+)$/;

export const matchRestockItemReceiverRoute = (pathname: string): ContinuationTarget | null => {
	const match = RESTOCK_ITEM_ROUTE_PATTERN.exec(pathname);
	if (!match) return null;
	try {
		return { targetId: decodeURIComponent(match[1]), targetKind: RESTOCK_ITEM_TARGET_KIND };
	} catch {
		return null;
	}
};

const restockItemReceiverIdentityAdapter: ReceiverIdentityAdapter = {
	buildCleanPath: ({ targetId }) => `${ITEMS_PATH}/${encodeURIComponent(targetId)}`,
	matchesRoute: matchRestockItemReceiverRoute
};

export default restockItemReceiverIdentityAdapter;
